import axios from "axios";
import { datosDelDiaPropio, usarAvancePropio } from "./AvancePropio";

export const getDateData = async (dateString: string, userId: number) => {
	if (usarAvancePropio()) return datosDelDiaPropio(dateString, userId).catch((error) => error);

	return axios
		.get(process.env.REACT_APP_API_URL + `studied-words/${dateString}/${userId}`)
		.then((res) => {
			return res.data;
		})
		.catch((error) => {
			console.error(error);
			return error;
		});
};
